import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  TEACHING_WORKLOAD_APPROVAL_ALL,
  TEACHING_WORKLOAD_APPROVAL_BY_ID,
  TEACHING_WORKLOAD_APPROVAL_RESPONSE,
  TEACHING_WORKLOAD_APPROVAL_SUBMIT,
  TEACHING_WORKLOAD_REPORT_BULK,
  TEACHING_WORKLOAD_REPORT_SINGLE,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const teachingWorkloadApprovalAll = createAsyncThunk(
  TEACHING_WORKLOAD_APPROVAL_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.TEACHING_WORKLOAD_APPROVAL_ALL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.teachingWorkloadApprovalAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const teachingWorkloadApprovalByID = createAsyncThunk(
  TEACHING_WORKLOAD_APPROVAL_BY_ID,
  async (
    params: PayloadCreatorParams<`${typeof API.TEACHING_WORKLOAD_APPROVAL_BY_ID}{id}`, 'get'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.teachingWorkloadApprovalByID(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const teachingWorkloadApprovalSubmit = createAsyncThunk(
  TEACHING_WORKLOAD_APPROVAL_SUBMIT,
  async (
    params: PayloadCreatorParams<`${typeof API.TEACHING_WORKLOAD_APPROVAL_SUBMIT}`, 'post'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.teachingWorkloadApprovalSubmit(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const teachingWorkloadApprovalResponse = createAsyncThunk(
  TEACHING_WORKLOAD_APPROVAL_RESPONSE,
  async (
    params: PayloadCreatorParams<`${typeof API.TEACHING_WORKLOAD_APPROVAL_RESPONSE}`, 'post'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.teachingWorkloadApprovalResponse(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const teachingWorkloadReportBulk = createAsyncThunk(
  TEACHING_WORKLOAD_REPORT_BULK,
  async (params: PayloadCreatorParams<`${typeof API.TEACHING_WORKLOAD_REPORT_BULK}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.teachingWorkloadReportBulk(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const teachingWorkloadReportSingle = createAsyncThunk(
  TEACHING_WORKLOAD_REPORT_SINGLE,
  async (params: PayloadCreatorParams<`${typeof API.TEACHING_WORKLOAD_REPORT_SINGLE}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.teachingWorkloadReportSingle(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const teachingWorkloadApprovalAllClear = createAction(`${TEACHING_WORKLOAD_APPROVAL_ALL}/clear`)

export const teachingWorkloadApprovalByIDClear = createAction(`${TEACHING_WORKLOAD_APPROVAL_BY_ID}/clear`)
